/**
 * Routini API — Management
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const TaxiTripDaySolveProcessStatus = {
    Pending: 'Pending',
    Queued: 'Queued',
    Running: 'Running',
    Completed: 'Completed',
    PartiallyCompleted: 'PartiallyCompleted',
    Failed: 'Failed',
    Cancelled: 'Cancelled'
} as const;
export type TaxiTripDaySolveProcessStatus = typeof TaxiTripDaySolveProcessStatus[keyof typeof TaxiTripDaySolveProcessStatus];

